import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { TCCPCommonService } from '../../services/tccp-common.service';


@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss']
})
export class PopupModalComponent implements OnInit {
  public appName = environment.applicationName;
  public hide = false ;

  constructor(
    public dialogRef: MatDialogRef<PopupModalComponent>, @Inject(MAT_DIALOG_DATA) public message: string,
    public commonService: TCCPCommonService) {
  }

  ngOnInit() {
    this.hide = false ;
  }

  changePosition() {
    this.dialogRef.updatePosition({ top: '50px', left: '50px' });
  }

  closed(): void {
    const element = document.querySelector('.cdk-overlay-container');
    const overlayContainer = document.querySelector('.cdk-global-scrollblock');
    if (element && this.appName === 'toyota') {
      this.hide = true;
      document.getElementById('toyota_last_step_popup').remove();
      element.remove();
      overlayContainer.classList.remove('cdk-global-scrollblock');
    } else if (element && this.appName === 'lexus') {
      document.getElementById('lexus_last_step_popup').remove();
      this.hide = true;
      element.remove();
      overlayContainer.classList.remove('cdk-global-scrollblock');
    }

  }

  close(): void {
    this.dialogRef.close();
  }

  backToDashboard() {
    this.commonService.backToDashboardFlow.emit(true);
  }
  getDoneFlow() {
    this.commonService.getDoneFlow.emit(true);
  }
}
